import React, {useEffect} from "react";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import {Typography} from "@material-ui/core";
import VideoPlayer from 'react-simple-video-player';
import {makeStyles} from "@material-ui/core/styles";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import {amber, blueGrey} from '@material-ui/core/colors';
import {ActitudesSources} from "../Source/ActitudesSources";
import CardActionArea from "@material-ui/core/CardActionArea";
import {useAppContext} from "../libs/contextLib";
import {USER_MAJOR} from "../App";

const useStyles = makeStyles((theme) => ({
    root: {
        color: blueGrey[800],
    },
    section: {
        paddingTop: '20px'
    },
    welcomeVideo: {
        padding: '50px 0 35px 0',
        textAlign: 'center'
    },
    card: {
        maxWidth: '500px'
    },
    mission: {
        backgroundColor: '#d6e0f0',
    },
    header: {
        textAlign: 'center'
    },
    vision: {
        background: 'url(https://sim4r4-public.s3.amazonaws.com/enfermeriauvt-source/Images/BackgroundUVT.jpeg)',
        backgroundSize: '100%',
        opacity: '.85',
        backgroundRepeat: 'no-repeat',
        margin: '50px 0 0 0',
        color: 'white',
        textAlign: 'center',
        height: '20rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    divSeparator: {
        height: '80px'
    },
    mision: {
        paddingTop: '35px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        borderTop: '2px solid rgb(31, 155, 207)',
        borderBottom: '2px solid rgb(31, 155, 207)',
        fontSize: '1.5em',
        paddingBottom: '50px',
    },
    logoAdminImage: {
        padding: '0 0 35px 0'
    },
    welcomeBanner: {
        textAlign: 'center',
        backgroundColor: amber[500],
        color: "white",
        height: '8rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    }
}));

export default function Home(props) {
    const {userHasAuthenticated} = useAppContext();
    const {userEmail} = useAppContext();
    const logoUrl = `http://uvt-public-assets.s3-accelerate.amazonaws.com/logo-${USER_MAJOR[userEmail]}.png`;
    const classes = useStyles();

    useEffect(() => {
        console.log(`http://uvt-public-assets.s3-accelerate.amazonaws.com/logo-${USER_MAJOR[userEmail]}.png`, 'url');
    }, [props.isAuthenticated, userEmail]);

    return (
        <div className={classes.root}>
            <Header classes={classes} logoUrl={logoUrl}/>
            <WelcomeVideo classes={classes}/>
            <Mision classes={classes}/>
            <Vision classes={classes}/>
            <Actitudes classes={classes}/>
        </div>
    );
}

function Header({classes, logoUrl}) {
    return (
        <div>
            <div className={classes.header}>
                <Typography variant="h2" gutterBottom>
                    Universidad Vasconcelos de Tabasco
                </Typography>
                <div className={classes.logoAdminImage}>
                    <img width='441px'
                         src={logoUrl}
                    />
                </div>
            </div>
        </div>
    );
}

function WelcomeVideo({classes}) {
    return (
        <div>
            <div className={classes.welcomeBanner}>
                <Typography variant="h3">
                    Mensaje de Bienvenida
                </Typography>
            </div>
            <div className={classes.welcomeVideo}>
                <VideoPlayer
                    // width={250}
                    aspectRatio='3:3'
                    url="https://sim4r4-public.s3.amazonaws.com/enfermeriauvt-source/Videos/video-bienvenida.MP4"
                    poster="https://sim4r4-public.s3.amazonaws.com/enfermeriauvt-source/Images/Video+Bienvenida+Enfermeria.jpg"
                />
            </div>
        </div>
    )
}

function Mision({classes}) {
    return (
        <blockquote className={classes.mision}>
            <p className="mb-0 text-primary">Somos una institución educativa comprometida con el desarrollo de
                una educación integral basada en competencias, que permite a sus estudiantes formarse como
                individuos responsables, emprendedores y comprometidos que contribuyen a satisfacer las demandas
                del entorno social, natural, cultural y económico del país.</p>
            <footer className="blockquote-footer mt-2">
                <cite title="Misión UVT">- Misión UVT</cite>
            </footer>
        </blockquote>
    );
}

function Vision({classes}) {
    return (
        <div className={classes.vision}>
            <Typography variant="h4">
                Visión UVT
            </Typography>
            <Typography variant="h5">
                Ser la mejor institución educativa privada del estado, con programas educativos certificados; una
                plantilla docente altamente competitiva, formadora de individuos reconocidos por el alto nivel de
                desarrollo de sus competencias e insertos exitosamente en el entorno social y laboral.
            </Typography>
        </div>
    );
}

function Actitudes({classes}) {
    return (
        <div>
            <Typography variant='h3' style={{padding: '50px 0px'}}>Actitudes y Valores</Typography>
            <Grid container spacing={2}>
                {ActitudesSources.map(resource => {
                    return <Grid item xs={6}>
                        <Card className={classes.card}>
                            <CardActionArea>
                                <CardMedia
                                    component="img"
                                    alt={resource.alt}
                                    height="200"
                                    width="280"
                                    image={resource.url}
                                    title={resource.title}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="h2">
                                        {resource.title}
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" component="p">
                                        {resource.description}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                })}
            </Grid>
        </div>
    );
}
